import React, { useEffect, useState } from 'react';
import { companyEmail, emailSendFeedback } from './companyEmail';
import { CompanySettingsNotice } from './CompanySettingsSection';
import './companyEmail.css';

export default function PayslipGroupNotification({ company, month, year, published, blocked = false }) {
  const [view, setView] = useState(null);
  const [busy, setBusy] = useState(false);
  const [message, setMessage] = useState('');
  const [error, setError] = useState(false);
  useEffect(() => {
    let active = true;
    setView(null); setMessage(''); setError(false);
    companyEmail(company.id).then(result => { if (active) setView(result); }).catch(error => {
      if (active) { setError(true); setMessage(error.message); }
    });
    return () => { active = false; };
  }, [company.id]);
  const group = view?.settings?.group_email;
  const ready = Boolean(view?.service_configured && view.settings?.verification_status === 'verified' && group);
  const period = new Date(year, month - 1, 1).toLocaleString('en-IN', { month: 'long', year: 'numeric' });
  async function send() {
    if (busy || blocked || !published || !ready) return;
    if (!window.confirm(`Send the ${period} payslip-ready announcement to ${group}? The message contains no individual salary or login credentials.`)) return;
    setBusy(true); setMessage(''); setError(false);
    try { setMessage(emailSendFeedback(await companyEmail(company.id, 'send', { kind: 'payslip_group', month, year }))); }
    catch (error) { setError(true); setMessage(error.message); }
    finally { setBusy(false); }
  }
  return <section className="company-settings-section company-payslip-publish" aria-label="Publish payslips">
    <h3 className="company-settings-step-title">Publish payslips · {period}</h3>
    <p className="company-settings-description">Lock payroll to make payslips available in the employee portal. Then send a general announcement to the employee group.</p>
    <div className="company-settings-actions">
      <button type="button" className="company-settings-action company-email-glass" disabled={busy || blocked || !published || !ready} onClick={send}>{busy ? 'Sending…' : 'Notify group'}</button>
      <span className="company-settings-record-meta">{!published ? 'Lock payroll before notifying employees.' : !view ? 'Loading sender settings…' : !group ? 'Add an employee group email in company sender settings.' : !ready ? 'Verify the company sender before sending.' : `Send to ${group}`}</span>
    </div>
    <p className="company-settings-hint">The group must allow messages from the approved sender. Invitations are sent individually; salary amounts are kept out of the announcement.</p>
    <CompanySettingsNotice message={message} error={error} onDismiss={() => setMessage('')}/>
  </section>;
}
